const input = {
  name: 'findPwdInput',
  path: 'input',
  component: resolve => require(['../../../../pages/custom/find-pwd/input'], resolve)
}

export default input
